import { Box, Container } from '@mui/material';
import { StudioPage } from '../../../page-templates/StudioPage';
import * as styles from './Dashboard.styles';
import { DashboardCollectionSection } from './sections/DashboardCollectionSection';
import { DashboardPopularSection } from './sections/DashboardPopularSection';
import { DashboardStatsSection } from './sections/DashboardStatsSection';
import { HeaderSection } from './sections/HeaderSection';
import { HelpSection } from './sections/HelpSection';

export const Dashboard = () => {
  return (
    <StudioPage>
      <HeaderSection />

      <Container maxWidth={false} sx={styles.container}>
        <Box sx={styles.sectionContainer}>
          <DashboardStatsSection />
        </Box>

        <Box sx={styles.sectionContainerWithPosition}>
          <DashboardCollectionSection />
        </Box>

        <Box sx={styles.sectionContainerWithPosition}>
          <DashboardPopularSection />
        </Box>

        <Box sx={styles.sectionContainer}>
          <HelpSection />
        </Box>
      </Container>
    </StudioPage>
  );
};
